import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from "@angular/router";
import {PaymentService} from "../../core/services/payment/payment.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {catchError, of} from "rxjs";

@UntilDestroy()
@Component({
  selector: 'confirm-page',
  imports: [
    RouterLink
  ],
  standalone: true,
  templateUrl: './confirm-page.component.html',
  styleUrl: './confirm-page.component.scss'
})
export class ConfirmPageComponent {

  constructor(private router: Router, private paymentService: PaymentService) {
  }


  confirm() {
    this.paymentService.unsubscribe(history.state.code)
      .pipe(
        untilDestroyed(this),
        catchError(error => {
          console.error('Ошибка отписки:', error);
          return of(null);
        })
      ).subscribe(res => {
      this.router.navigate(['success',]);
    });
  }
}
